import './Overlay.css';

/** Semi-transparent backdrop used behind modals, drawers, and popovers. */
export type OverlayProps = {
  className?: string;
};

export function Overlay({ className = '' }: OverlayProps) {
  return (
    <div
      className={['spark-overlay', className].filter(Boolean).join(' ')}
      aria-hidden="true"
    >
      <div className="spark-overlay-scrim" />
    </div>
  );
}
